import React, { useEffect, useState } from 'react'
import { Card, Table } from 'reactstrap'
import MyPagination from '../pagination'
import { useCurrency } from '../../_helper/currencyContext';
import { getLabTransaction } from './service/transaction-service';
import { useLoader } from '../../_helper/LoaderContext';
import { formatDate } from '../../utils/formatDate';
import { Tooltip } from 'react-tooltip';
import { Eye, EyeOff } from "lucide-react";
import Payment from '../ladger/Payment';
import { getInvoiceDetail } from '../ladger/service/ledger-service';
import { FormLabel, Modal } from 'react-bootstrap';

// const amounts = {
//     USD: 8759,
//     INR: 582506.61,
//     EUR: 30
// };

const gradients = {
    USD: "tw-bg-gradient-to-r tw-from-yellow-400 tw-to-yellow-600",
    EUR: "tw-bg-gradient-to-r tw-from-yellow-400 tw-to-yellow-600",
    INR: "tw-bg-gradient-to-r tw-from-teal-400 tw-to-teal-600",
    default: "tw-bg-white tw-border tw-border-gray-300 tw-shadow-sm"
};

const formatNumber = (num) => {
    if (num >= 1_000_000_000) return (num / 1_000_000_000).toFixed(1) + "B";
    if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + "M";
    if (num >= 1_000) return (num / 1_000).toFixed(1) + "K";
    return num;
};

export default function TransactionHome() {
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalEntries, setTotalEntries] = useState(0);
    const { setLoading } = useLoader();
    const { getCurrencySymbol, convertCurrency, currency } = useCurrency();
    const [transaction, setTransaction] = useState([]);
    const [wallets, setWallets] = useState({})
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [trData, setTrData] = useState({})
    const [data, setData] = useState({})
    const [showMap, setShowMap] = useState({
        USD: false,
        INR: false,
        EUR: false,
    });

    const toggleShow = (key) => {
        setShowMap((prev) => ({ ...prev, [key]: !prev[key] }));
    };

    useEffect(() => {
        getList()
    }, [currentPage, entriesPerPage, search])

    const getList = async () => {
        setLoading(true)
        try {
            const form_data = new FormData()
            form_data.append("search", search);
            form_data.append("page", currentPage);
            form_data.append("limit", entriesPerPage);
            const res = await getLabTransaction(form_data)
            if (res.data.success == true) {
                setTransaction(res.data.data.transactions)
                setTotalEntries(res.data.data.total || 0);
                setWallets(res.data.data.wallets)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }

    const totalPages = Math.ceil(totalEntries / entriesPerPage);

    const openModel = async (data) => {
        setLoading(true)
        try {
            const res = await getInvoiceDetail(data?.data?.orderId);
            if (res.data.success == true) {
                setShow(true)
                setTrData(res.data.data)
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }

    }

    const openPayOut = (data) => {
        setShow1(true);
        setData(data);
    }

    const handlePageSizeChange = (e) => {
        const newSize = Number(e.target.value);
        setEntriesPerPage(newSize);  // Use the correct setter
        setCurrentPage(1);           // Reset to page 1
    }

    const getStartingSerialNumber = () => {
        return (currentPage - 1) * entriesPerPage + 1;
    };

    return (
        <>
            <div className="row">
                {/* {Object.keys(wallets).map((currency) => (
                    <div className="col-md-4" key={currency}>
                        <div
                            className={`d-flex justify-content-between align-items-center p-4 card-body tw-rounded-lg ${gradients[currency]}`}
                        >
                            <div>

                                <div className="fw-bold mb-0 tw-text-2xl">
                                    {showMap[currency] ? (
                                        <>
                                            {getCurrencySymbol(currency)}
                                            {Number(wallets[currency]).toLocaleString('en-US', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}
                                        </>
                                    ) : (
                                        <div>••••</div>
                                    )}
                                </div>
                            </div>

                            <button
                                onClick={() => toggleShow(currency)}
                                className="btn btn-light btn-sm shadow-sm"
                            >
                                {showMap[currency] ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                    </div>
                ))} */}
                {Object.keys(wallets).map((currency) => (
                    <div className="col-md-4 mb-3" key={currency}>
                        <div
                            className={`d-flex justify-content-between align-items-center p-4 card-body tw-rounded-lg 
                ${gradients[currency] || gradients.default} 
                tw-text-gray-800`}  // Optional: ensure text is readable on white bg
                        >
                            {/* Title */}
                            <div>
                                <p className="tw-text-md tw-font-semibold mb-0">{currency} Wallet</p>
                                {/* Full Amount */}
                                <div className="fw-bold mb-0 tw-text-2xl">
                                    {showMap[currency] ? (
                                        <>
                                            {getCurrencySymbol(currency)}
                                            {Number(wallets[currency]).toLocaleString('en-US', {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                            })}
                                        </>
                                    ) : (
                                        <div>••••••••</div>
                                    )}
                                </div>
                            </div>

                            {/* Eye Toggle Button */}
                            <button
                                onClick={() => toggleShow(currency)}
                                className="btn btn-light btn-sm shadow-sm"
                            >
                                {showMap[currency] ? <EyeOff size={18} /> : <Eye size={18} />}
                            </button>
                        </div>
                    </div>
                ))}

            </div>

            <Card className='mt-3'>
                <div className="tw-px-3 tw-py-4">
                    <div className="recent-table table-responsive currency-table tw-rounded-lg tw-border tw-border-black"
                    >
                        <Table className="mb-0 table-center table-bordered table-hover" style={{ overflowX: "auto", tableLayout: "fixed" }}>
                            <thead>
                                <tr>
                                    <th className="text-center bg-primary tw-text-center" style={{
                                        width: "80px"   // 👈 add width only to first column
                                    }}>
                                        <b>#</b>
                                    </th>
                                    {/* <th className="bg-primary text-white" style={{ width: "10px" }}><b>#</b></th> */}
                                    <th className="bg-primary text-white" style={{ width: "125px" }}><b>Transaction Type</b></th>
                                    <th className="bg-primary text-white" style={{ width: "80px" }}><b>Credit</b></th>
                                    <th className="bg-primary text-white" style={{ width: "80px" }}><b>Debit</b></th>
                                    <th className="bg-primary text-white" style={{ width: "160px" }}><b>Balance</b></th>
                                    <th className="bg-primary text-white" style={{ width: "100px" }}><b>Date</b></th>
                                    <th className="bg-primary text-white" style={{ width: "80px" }}><b>Paid In</b></th>
                                    <th className="bg-primary text-white text-center" style={{ width: "80px" }}><b>Action</b></th>
                                </tr>
                            </thead>
                            <tbody>
                                {transaction.length > 0 ? (
                                    transaction.map((item, index) => {
                                        const serialNumber = getStartingSerialNumber() + index;
                                        return (
                                            <tr key={item._id} className={index % 2 === 0 ? '' : ''}>
                                                <td className="text-center font-weight-bold">
                                                    {serialNumber}
                                                </td>
                                                <td className="tw-px-3 tw-py-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                    <div className={`tw-font-bold tw-text-gray-900 text-capitalize tw-ps-3 ${item.transactionType === "credit"
                                                        ? "text-success"
                                                        : item.transactionType === "debit"
                                                            ? "text-danger"
                                                            : "tw-text-gray-900"
                                                        }`}>
                                                        {item.actionType}{(item.actionType === "payOut" && item.transactionType === "debit") && (
                                                            <span className="tw-text-gray-600" style={{ fontSize: '10px' }} data-tooltip-id="name-tooltip"
                                                                data-tooltip-content={item.reason}> <i className='bi bi-info-circle'></i> </span>
                                                        )}
                                                        <Tooltip id="name-tooltip" place="top" />
                                                    </div>
                                                </td>
                                                <td className='text-success fw-bold'>
                                                    {item.transactionType == "credit" ? (
                                                        <>
                                                            {getCurrencySymbol(item.currencyType)}{item.amount?.toFixed(2)}
                                                        </>
                                                    ) : (
                                                        <div>-- </div>
                                                    )}
                                                </td>
                                                <td className='text-danger fw-bold'>
                                                    {item.transactionType == "debit" ? (
                                                        <>
                                                            {getCurrencySymbol(item.currencyType)}{item.amount?.toFixed(2)}
                                                        </>
                                                    ) : (
                                                        <div>-- </div>
                                                    )}
                                                </td>
                                                <td className='fw-bold'>
                                                    {item.currencyType && item.wallets
                                                        ? `${getCurrencySymbol(item.currencyType)}${Number(item.wallets[item.currencyType]).toFixed(2)}`
                                                        : "-"}
                                                </td>
                                                <td>
                                                    {formatDate(item.createdAt)}
                                                </td>
                                                <td>
                                                    <div className="fw-bold"> {item.currencyType}</div>
                                                </td>
                                                <td className="tw-px-4 tw-py-4 text-center">
                                                    <div className="">
                                                        {item.actionType == "sale" ? (
                                                            <button className='success-action-button me-1' data-tooltip-id="invoice" onClick={() => openModel(item)}>
                                                                <i className="fa fa-eye" style={{ fontSize: "18px" }}></i>
                                                            </button>
                                                        ) : (
                                                            <button className='success-action-button me-1' data-tooltip-id="invoice" onClick={() => openPayOut(item)}>
                                                                <i className="fa fa-eye" style={{ fontSize: "18px" }}></i>
                                                            </button>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    }
                                    )
                                ) : (
                                    <tr>
                                        <td
                                            colSpan={8}
                                            className="text-center py-4 text-muted"
                                        >
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                    <div className="d-md-flex align-items-center text-center justify-content-between mt-3 mb-3">
                        <div className="show-entries">
                            <FormLabel>Show&nbsp;</FormLabel>
                            <select style={{ display: 'unset', width: 'auto', padding: '0.375rem 2.25rem 0.375rem 0.75rem' }} value={entriesPerPage}
                                onChange={handlePageSizeChange} className="form-control">
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={30}>30</option>
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                            </select>&nbsp;
                            <FormLabel>entries</FormLabel>
                        </div>
                        <MyPagination totalPages={totalPages} currentPage={currentPage} onPageChange={(page) => setCurrentPage(page)} />
                    </div>
                    {/* <div className="mt-3">
                        <MyPagination totalPages={totalPages}
                            currentPage={currentPage}
                            onPageChange={(page) => setCurrentPage(page)}></MyPagination>
                    </div> */}
                </div>
            </Card>
            <Payment show={show} onHide={() => setShow(false)} trData={trData} />

            <Modal show={show1} onHide={() => setShow1(false)} scrollable centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Payment Detail
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p><b>Payment Data</b> : {formatDate(data?.createdAt)}</p>
                    <label className='tw-font-bold'>Reason :</label><br />
                    {data?.reason}
                </Modal.Body>
            </Modal>
        </>
    )
}
